import { CaretDownSolid } from "@/icons";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { Filter } from "./Filter";
import cn from "classnames";
import { FC } from "react";
import { Analytics } from "@/types";
import { getDataLinkAttributes } from "@/helpers";
import { TreeNode } from "@/types/General";

type FiltersProps = {
  defaultOpen?: boolean;
  sortByName?: boolean;
  analytics: Analytics;
  selectAll: { text: string } & Analytics;
  deselectAll: { text: string } & Analytics;
  filters: {
    label: string;
    name: string;
    categories: TreeNode[];
  }[];
  selectedFilters: { name: string; paths: string[] }[];
  onSelectFilters: (name: string, paths: string[]) => void;
  onDeselectFilters: (name: string, paths: string[]) => void;
};
export const RootFilters: FC<FiltersProps> = ({
  defaultOpen = false,
  sortByName = true,
  analytics,
  filters,
  selectAll,
  deselectAll,
  selectedFilters,
  onSelectFilters,
  onDeselectFilters,
}) => {
  return (
    <div className="index-scrollbar flex max-h-[85vh] flex-col justify-start gap-4 overflow-y-auto pr-2">
      {filters.map(({ label, name, categories }) => {
        const sortedCategories = sortByName
          ? [...categories].sort(({ name: nameA }, { name: nameB }) =>
              nameA < nameB ? -1 : nameA === nameB ? 0 : 1,
            )
          : categories;
        return (
          <Disclosure key={label} defaultOpen={defaultOpen}>
            {({ open }) => (
              <div className="flex flex-col gap-y-2">
                <DisclosureButton
                  data-automation-group="filter-category"
                  className="text-link-m text-tab-link hover:text-tab-link-hover active:text-tab-link-pressed flex flex-row items-center gap-x-1.5 p-2 text-left font-medium hover:bg-white hover:underline"
                  {...getDataLinkAttributes({
                    dld: `${analytics.dld}: ${label}`,
                    dlt: analytics.dlt,
                  })}
                >
                  <CaretDownSolid
                    width="16"
                    height="16"
                    className={cn("inline", open && "rotate-180")}
                    aria-hidden
                  />
                  {label}
                </DisclosureButton>
                <DisclosurePanel className="text-swdc-gray-500 flex flex-col gap-y-3 pl-6.5">
                  {sortedCategories.map((filter) => {
                    return (
                      <Filter
                        key={`${filter.name}-${filter.type}`}
                        {...filter}
                        selectedFilters={
                          selectedFilters.find((filter) => filter.name === name)
                            ?.paths ?? []
                        }
                        analytics={analytics}
                        rootFilterName={label}
                        path={filter.name}
                        selectAll={selectAll}
                        deselectAll={deselectAll}
                        onSelectFilters={(path) => onSelectFilters(name, path)}
                        onDeselectFilters={(path) =>
                          onDeselectFilters(name, path)
                        }
                      />
                    );
                  })}
                </DisclosurePanel>
              </div>
            )}
          </Disclosure>
        );
      })}
    </div>
  );
};
